import React, { useEffect, useState } from "react";
import { SendSmsResp } from "../SendSms/SendSms.model";
import { sendSmsServive } from "../SendSms/SendSms.service";
import {
  IonModal,
  IonIcon,
  IonAlert,
  IonAvatar,
  IonItem,
  IonTextarea,
  IonCard,
  IonRow,
} from "@ionic/react";
import { utilService } from "../../../../../services";
import { chevronBackOutline, paperPlane } from "ionicons/icons";
import "./SendSms.scss";
import { ERROR } from "../../../../../constants/errorMessage.constants";
import { useToast } from "@agney/ir-toast";
import { CONSTANTS } from "../../../../../constants";
import _ from "lodash";
import InfiniteScroll from "react-infinite-scroll-component";
import MediaListCard from "../../../../../pages/FileShare/components/MediaListCard/MediaListCard";
import NoResults from "../../../NoResults/NoResultsComponent";

interface sendSmsParams {
  doctorInfoData: any;
  isShowSendSmsModal: boolean;
  isPrimaryNumber: boolean;
  isAssignedNumber?: boolean;
  pid?: any;
  unitId?: any;
  onCancel: () => void;
  onOk: () => void;
}

const SendSms: React.FC<sendSmsParams> = (props) => {
  const [sendSmsData, setSendSmsData]: any = useState([]);
  const [smsHistoryData, setSmsHistoryData]: any = useState([]);
  const [isApiCalling, setIsApiCalling] = useState(false);
  const [isInputEmpty, setIsInputEmpty] = useState(true);
  const [isShowAlert, setIsShowAlert] = useState(false);
  const [currentErrorMessage, setCurrentErrorMessage]: any = useState();
  const [currentTypedMessage, setCurrentTypedMessage]: any = useState();
  const [isSmallScreen, setIsSmallScreen]: any = useState(false);
  const [pageNo, setPageNo]: [number, Function] = useState(1);
  const [smsHistoryNextValue, setSmsHistoryNextValue]: any = useState("");
  const [messageDisposalLabel, setMessageDisposalLabel]: any = useState("");

  const Toast = useToast();

  useEffect(() => {
    checkIfSmallScreen();
  }, []);

  useEffect(() => {
    if (props.isShowSendSmsModal) {
      getSmsHistoryDetails();
    }
  }, [props.isShowSendSmsModal]);

  useEffect(() => {
    if (!props.isShowSendSmsModal) {
      setSmsHistoryData(_.cloneDeep([]));
      setSmsHistoryNextValue("");
      setPageNo(1);
    }
  }, [props.isShowSendSmsModal]);
  const checkIfSmallScreen = () => {
    if (utilService.getScreenSize() === "small") {
      setIsSmallScreen(true);
    } else {
      setIsSmallScreen(false);
    }
  };

  const getSmsHistoryDetails = async (page: number = 1) => {
    setIsApiCalling(true);
    const params: any = getSmsHistoryParams(page);
    const respSmsHistoryResult: any = await sendSmsServive.getSmsHistoryDetails(
      params
    );
    if (respSmsHistoryResult.isSuccess && respSmsHistoryResult.result?.[0]) {
      setSmsHistoryNextValue(respSmsHistoryResult.result?.[0]?.next);
      if (page === 1) {
        setSmsHistoryData(_.cloneDeep(respSmsHistoryResult.result?.[0]?.data));
      } else {
        setSmsHistoryData([
          ...smsHistoryData,
          ...respSmsHistoryResult.result?.[0]?.data,
        ]);
      }
      let smsHistoryResult = respSmsHistoryResult.result?.[0]?.data[0];
      setMessageDisposalLabel(smsHistoryResult?.media_disposal_info);
    } else {
      console.log("error");
      sendSmsServive.handleErrorResponse();
    }
    setIsApiCalling(false);
  };

  async function sendSms() {
    setIsApiCalling(true);
    const params: any = getApiParams();
    const respAddScheduleListResult: SendSmsResp =
      await sendSmsServive.sendSmstoSelectedDoctor(params);
    if (respAddScheduleListResult.isSuccess) {
      setSendSmsData(respAddScheduleListResult);
      showApiResponse(respAddScheduleListResult);
    } else {
      console.log("error");
      sendSmsServive.handleErrorResponse();
    }
    setIsApiCalling(false);
  }

  async function sendUnAssignedSms() {
    setIsApiCalling(true);
    const params: any = getApiParams();
    const respAddScheduleListResult: SendSmsResp =
      await sendSmsServive.sendSmstoUnAssignedNumber(params);
    if (respAddScheduleListResult.isSuccess) {
      setSendSmsData(respAddScheduleListResult);
      showApiResponse(respAddScheduleListResult);
    } else {
      console.log("error");
      sendSmsServive.handleErrorResponse();
    }
    setIsApiCalling(false);
  }

  const getApiParams = () => {
    var params = {};
    if (props.doctorInfoData.userData.assignNumber === true) {
      params = getAssignedNumberParms();
    } else {
      params = getSendSmsParams();
    }
    return params;
  };

  const getSmsHistoryParams = (page: number) => {
    var params = {
      time_zone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      from: utilService.getLoggedUserGuid().toString(),
      to: props.doctorInfoData.userData.guid.toString(),
      page: page,
    };
    return params;
  };

  const getSendSmsParams = () => {
    var mobileNumber: string;
    if (props.isPrimaryNumber) {
      mobileNumber = props.doctorInfoData.userData.mobileNumber;
    } else {
      mobileNumber = props.doctorInfoData.userData.alternateNumber;
    }
    return {
      to: props.doctorInfoData.userData.guid,
      from: utilService.getLoggedUserGuid(),
      text: currentTypedMessage,
      type: "sms",
      mobile_number: mobileNumber,
      reg_code: utilService.getNetwork(),
    };
  };

  const getAssignedNumberParms = () => {
    var mobileNumber: string;
    if (props.doctorInfoData.userData.assignNumber) {
      mobileNumber = props.doctorInfoData.userData.mobileNumber;
    } else if (
      !props.doctorInfoData.userData.assignNumber &&
      props.isPrimaryNumber
    ) {
      mobileNumber = props.doctorInfoData.userData.contactInfo[0].number;
    } else {
      mobileNumber = props.doctorInfoData.userData.contactInfo[1].number;
    }
    const userArray: any = [];
    userArray.push(props.doctorInfoData.userData.guid);
    const patientId = parseInt(props.pid);
    return {
      message_sms: currentTypedMessage,
      pid: patientId,
      reg_code: utilService.getNetwork(),
      time: utilService.getCurrentDateAndTime().toString(),
      users: userArray,
      unit_id: props.unitId,
    };
  };

  const checkIfInputEmpty = () => {
    const isWhitespace = utilService.checkIfInputEmpty("smsText");
    setIsInputEmpty(isWhitespace);
  };

  const setMessageOnSubitBUttonClick = () => {
    const inputField = document.getElementById("smsText");
    setCurrentTypedMessage(inputField?.textContent);
    initiateSendSmsApiCall();
  };

  const initiateSendSmsApiCall = () => {
    if (props.doctorInfoData.userData.assignNumber === true) {
      sendUnAssignedSms();
    } else {
      CheckIfSmsEnabled();
    }
  };

  const CheckIfSmsEnabled = () => {
    if (currentTypedMessage !== undefined && currentTypedMessage !== "") {
      if (
        (props.isPrimaryNumber &&
          props.doctorInfoData.userData.primaryCanSendSms) ||
        (!props.isPrimaryNumber &&
          props.doctorInfoData.userData.secondaryCanSendSms)
      ) {
        sendSms();
      } else {
        //show alert
        setCurrentErrorMessage(ERROR.sendSms.SMS_NOT_AVAILABLE);
        setIsShowAlert(true);
      }
    }
  };

  const showApiResponse = (sendSmsData: any) => {
    if (sendSmsData.status !== 200) {
      setCurrentErrorMessage(ERROR.sendSms.SMS_SENDING_FAILED);
      setIsShowAlert(true);
    } else if (sendSmsData.status === 200) {
      props.onCancel();
      Toast.success(CONSTANTS.MESSAGES.SMS_SUCCESS);
    }
  };

  const onScroll = () => {
    if (!_.isEmpty(smsHistoryNextValue)) {
      setPageNo(pageNo + 1);
      getSmsHistoryDetails(pageNo + 1);
    }
  };

  return (
    <div>
      <IonAlert
        isOpen={isShowAlert}
        onDidDismiss={() => setIsShowAlert(false)}
        cssClass="sms-alert"
        message={currentErrorMessage}
        buttons={[
          {
            text: "OK",
            handler: () => {
              setIsShowAlert(false);
            },
          },
        ]}
      />
      <IonModal
        isOpen={props.isShowSendSmsModal}
        backdropDismiss={false}
        className="send-sms-modal"
      >
        <div
          className={`doctor-card-sms ${
            isSmallScreen ? "doctor-card-sms-small-screen" : ""
          }`}
        >
          <div
            className="back-icon"
            onClick={() => {
              props.onCancel();
              setIsInputEmpty(true);
              setCurrentTypedMessage("");
            }}
          >
            <IonIcon icon={chevronBackOutline} />
          </div>
          <div className="profile-image">
            <IonAvatar>
              <img
                src={props.doctorInfoData.userData.image}
                alt="Ionic logo"
                className="doctor-profile-image"
                onError={(e: React.SyntheticEvent<HTMLImageElement, Event>) => {
                  const target = e.target as HTMLImageElement;
                  target.src = "assets/images/defaultProfilePic.png";
                }}
              />
            </IonAvatar>
          </div>
          <div
            className={`doctor-details ${
              isSmallScreen ? "doctor-details-small-screen" : ""
            }`}
          >
            <div className="doctor-name-label">
              {props.doctorInfoData.userData.firstName}{" "}
              {props.doctorInfoData.userData.lastName}
            </div>
            <div className="group-details">
              {props.doctorInfoData.userData.groups.toString()}
            </div>
          </div>
        </div>
        <span className="message-info-message">{messageDisposalLabel}</span>

        <InfiniteScroll
          dataLength={smsHistoryData.length}
          height={480}
          className="display-sms-container"
          next={() => onScroll()}
          hasMore={true}
          loader={<div></div>}
        >
          {!_.isEmpty(smsHistoryData) ? (
            smsHistoryData.map((historyItem: any) => {
              return (
                <IonCard
                  className={`sms-history-wrapper ${
                    historyItem.request_type === "received" &&
                    "received-sms-wrapper"
                  }
                ${historyItem.request_type === "sent" && "sent-sms-wrapper"}
                ${historyItem.isExpired ? "expired-media" : ""}     
            `}
                >
                  <div className="message-content">
                    <div> {historyItem.isExpired ? "media expired" : ""} </div>
                    {historyItem.message}
                    {historyItem.is_media && (
                      <IonRow>
                        {!_.isEmpty(historyItem.media_data) ? (
                          historyItem.media_data.map((item: any) => {
                            return (
                              <div>
                                <MediaListCard
                                  selectedPatientId={
                                    historyItem.selectedPatientId
                                  }
                                  selectedUserId={historyItem.selectedUserGuid}
                                  mediaItem={item}
                                  selectedDoctorData={
                                    historyItem.selectedDoctorDetails
                                  }
                                  fromHistoryList={true}
                                  fromHomeUserChat={true}
                                ></MediaListCard>
                              </div>
                            );
                          })
                        ) : (
                          <div>
                            <NoResults></NoResults>
                          </div>
                        )}
                      </IonRow>
                    )}
                  </div>

                  <div className="message-date">
                    {utilService.getShortDateWithYear(historyItem.created_on)}
                  </div>
                </IonCard>
              );
            })
          ) : (
            <div className="no-sms-div">No chat history</div>
          )}
        </InfiniteScroll>

        <div className="position-bottom bottom-container">
          <div className="text-area-div">
            <IonItem
              class="form-field text-message text-field-div"
              lines="none"
            >
              <IonTextarea
                className="field-input"
                placeholder="Maximum 250 characters"
                maxlength={250}
                name="message"
                id="smsText"
                onIonChange={(e) => {
                  checkIfInputEmpty();
                  setCurrentTypedMessage(e.detail.value!);
                }}
                autoGrow={false}
              ></IonTextarea>
            </IonItem>
          </div>
          <div className="sms-button-container">
            <div
              className=" send-sms-button"
              item-right
              onClick={() => {
                setMessageOnSubitBUttonClick();
                setCurrentTypedMessage("");
              }}
            >
              <IonIcon icon={paperPlane} />
            </div>
          </div>
        </div>
      </IonModal>
    </div>
  );
};

export default SendSms;
